package games.polyclub.website.frontend.store.pages.skyfactory

import games.polyclub.frontend.lib.react.simplified.SFC
import games.polyclub.frontend.lib.react.simplified.tags.*
import games.polyclub.frontend.lib.react.utils.classSet
import react.Props
import react.dom.aria.ariaExpanded
import react.useState
import web.window.WindowTarget

val SkyFactoryHowToInstall = SFC<Props> { _ ->
    val (isInstallTutorialPrismLauncherExpanded, setInstallTutorialPrismLauncherExpanded) = useState(false)
    val (isInstallTutorialCustomExpanded, setInstallTutorialCustomExpanded) = useState(false)
    val (isInstallTutorialNoPrismExpanded, setInstallTutorialNoPrismExpanded) = useState(false)
    p {
        +"Pegamos o "
        a {
            href = "https://www.curseforge.com/minecraft/modpacks/skyfactory-4"
            target = WindowTarget._blank
            +"SkyFactory 4 no CurseForge"
        }
        +" e melhoramos um pouco ele, corrigindo alguns bugs, atualizando alguns mods, e adicionando alguns mods novos."
    }
    p {
        +"Portanto, para jogar você precisa baixar a nossa versão do modpack, o GameMods: SkyFactory 4"
    }
    p {
        +"Usamos o PrismLauncher, um fork moderno do MultiMC, para distribuir o modpack."
    }

    div {
        div("card card-green mb-1") {
            div("card-header") {
                h4("card-title w-100") {
                    a("d-block w-100 cursor-pointer") {
                        if (!isInstallTutorialPrismLauncherExpanded) {
                            classSet += "collapsed"
                        }
                        href="#"
                        ariaExpanded = isInstallTutorialPrismLauncherExpanded
                        +"Se você ainda não tem o PrismLauncher:"
                        onClick = { ev ->
                            ev.preventDefault()
                            setInstallTutorialPrismLauncherExpanded(!isInstallTutorialPrismLauncherExpanded)
                        }
                    }
                }
            }
            div("collapse") {
                if (isInstallTutorialPrismLauncherExpanded) {
                    classSet += "show"
                }
                div("card-body") {
                    p {
                        +"Distribuímos um zip pronto para uso com o PrismLauncher e o modpack atualizado já instalado, bastando apenas dezipar, executar o prismlaucher.exe, fazer login e abrir o modpack dentro dele."
                    }

                    p {
                        +"Se você preferir, você pode baixar o PrismLauncher e instalar o modpack manualmente, mas não recomendamos, já que o zip já vem com tudo pronto."
                    }

                    a {
                        href = "https://skyfactory.gamemods.com.br/download/GameMods-SkyFactory4-PrismLauncher.zip"
                        target = WindowTarget._blank
                        +"➡️ Clique aqui para baixar o PrismLauncher com o modpack instalado"
                    }
                    br()
                    a {
                        href = "https://prismlauncher.org/download/"
                        target = WindowTarget._blank
                        +"➡️ Clique aqui para baixar o PrismLauncher do site oficial"
                    }
                }
            }
        }
        div("card card-gray-dark mb-1") {
            div("card-header") {
                h4("card-title w-100") {
                    a("d-block w-100 cursor-pointer") {
                        if (!isInstallTutorialCustomExpanded) {
                            classSet += "collapsed"
                        }
                        href="#"
                        ariaExpanded = isInstallTutorialCustomExpanded
                        +"Se você já tem o PrismLauncher:"
                        onClick = { ev ->
                            ev.preventDefault()
                            setInstallTutorialCustomExpanded(!isInstallTutorialCustomExpanded)
                        }
                    }
                }
            }
            div("collapse") {
                if (isInstallTutorialCustomExpanded) {
                    classSet += "show"
                }
                div("card-body") {
                    p {
                        +"Basta você baixar o zip do modpack e importar no PrismLauncher, clicando em:"
                        br()
                        +"Adicionar instância -> Importar (.zip)"
                    }
                    p {
                        a {
                            href = "https://skyfactory.gamemods.com.br/download/GameMods-SkyFactory4.zip"
                            target = WindowTarget._blank
                            +"➡️ Clique aqui para baixar o modpack"
                        }
                    }
                }
            }
        }
        div("card card-danger mb-1") {
            div("card-header") {
                h4("card-title w-100") {
                    a("d-block w-100 cursor-pointer") {
                        if (!isInstallTutorialNoPrismExpanded) {
                            classSet += "collapsed"
                        }
                        href="#"
                        ariaExpanded = isInstallTutorialNoPrismExpanded
                        +"Não quero usar o PrismLauncher!"
                        onClick = { ev ->
                            ev.preventDefault()
                            setInstallTutorialNoPrismExpanded(!isInstallTutorialNoPrismExpanded)
                        }
                    }
                }
            }
            div("collapse") {
                if (isInstallTutorialNoPrismExpanded) {
                    classSet += "show"
                }
                div("card-body") {
                    p {
                        +"Bom, esta é sua opção, você pode usar qualquer launcher de Minecraft Java Edition que suporte mods, até mesmo o original da Mojang pode ser usado, mas você terá que ajustar a instalação você mesme, todos os mods e configurações estão disponíveis em ambos os zips acima, basta adaptar para o launcher que você deseja usar."
                    }
                }
            }
        }
    }
}
